import _ from 'lodash';
import uuid4 from 'uuid/v4';
import React from 'react';

import Button from 'components/Button';
import Warning from 'components/Warning';
import ErrorBlock from 'components/ErrorBlock';
import {default as Modal, withModal} from 'components/Modal';
import {
  MODALS,
  fetchSendGocardlessInvitationWarnings,
  fetchGocardlessCustomerAndInvitation,
  sendGoCardlessInvitation
} from 'ducks/tenancy';
import {closeModal, storeDataInModal} from 'ducks/modals';

import './styles.css';

class SendGocardlessInvitationConfirmModal extends React.Component<any> {
  componentDidMount() {
    const {data: {tenancyId, tenantId}} = this.props;

    const successExtraActions = this.props.storeDataExtraActions(data => ({
      warnings: data.warnings
    }));
    const failureExtraActions = this.props.storeDataExtraActions(data => ({
      errors: data.errors
    }));

    this.props.fetchSendGocardlessInvitationWarnings(
      {tenancyId, tenantId},
      successExtraActions,
      failureExtraActions
    );
  }

  sendInvitation = () => {
    const {data: {tenancyId, tenantId}} = this.props;
    this.props.storeDataInModal({
      modalName: MODALS.SEND_GOCARDLESS_INVITATION_CONFIRM,
      data: {isSending: true}
    });

    const successExtraActions = [
      ...this.props.closeModalExtraActions,
      ...this.props.storeDataExtraActions(() => ({isSending: false})),
      () => closeModal(MODALS.SETUP_GOCARDLESS),
      () => fetchGocardlessCustomerAndInvitation({tenancyId})
    ];

    const failureExtraActions = this.props.storeDataExtraActions(data => ({
      errors: data._error,
      isSending: false
    }));

    this.props.sendGoCardlessInvitation(
      {tenancyId, tenantId},
      successExtraActions,
      failureExtraActions
    );
  };

  render() {
    const {warnings, errors, isSending} = this.props.data;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="SendGocardlessInvitationConfirmModal"
        type={Modal.SMALL}>
        <Modal.Header>
          <h3 className="heading">Send GoCardless Invitation</h3>
        </Modal.Header>
        <Modal.Body>
          {!_.isEmpty(warnings) &&
            _.map(warnings, warning => (
              <Warning key={uuid4()}>{warning}</Warning>
            ))}
          {_.isEmpty(warnings) && (
            <Warning>There are no previous invitations for that tenant</Warning>
          )}
          {errors && <ErrorBlock>{errors}</ErrorBlock>}
        </Modal.Body>
        <Modal.Footer>
          <Button red onClick={this.sendInvitation} disabled={isSending}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});
const mapDispatchToModalProps = {
  sendGoCardlessInvitation,
  fetchSendGocardlessInvitationWarnings,
  storeDataInModal
};

export default withModal(
  MODALS.SEND_GOCARDLESS_INVITATION_CONFIRM,
  mapStateToModalData,
  mapDispatchToModalProps
)(SendGocardlessInvitationConfirmModal);
